module.exports = __webpack_public_path__ + "static/img/placeholder.3b912e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/placeholder.jpg
// module id = 0ugF
// module chunks = 1